/* LE IMMAGINI DELLA SKIN: da dove si scaricano.
 *
 * Il logo, i banner e i loghi degli enti arrivano dalla skin come indirizzi.
 * Sono di due specie:
 *
 *   - un indirizzo completo (https://…/banner.png): un'immagine che sta gia'
 *     da qualche parte su internet. Si usa cosi' com'e';
 *   - un'immagine CARICATA dal backoffice: il servizio delle skin la conserva
 *     e ne da' il percorso SULL'API, senza dominio (/api/tenants/file/…).
 *     Senza dominio di proposito: lo stesso valore resta buono il giorno in
 *     cui l'API cambia indirizzo o passa a https. Qui gli si mette davanti
 *     l'indirizzo dell'API, lo stesso da cui il sito ha letto la skin.
 *
 * Non e' un valore di ripiego: e' solo dove si trova il file. Se l'indirizzo
 * manca non si inventa niente, e chi disegna mostra il posto vuoto.
 */
const CARICATA = '/api/tenants/file/';

export function indirizzoImmagine(v) {
  if (typeof v !== 'string') return v;
  const s = v.trim();
  if (s.indexOf(CARICATA) !== 0) return s;
  const env = (typeof window !== 'undefined' && window.env) || {};
  return String(env.REACT_APP_API_URL || '').replace(/\/+$/, '') + s;
}
